import Icon from '../components/Icon.vue'

Icon.register({
  'dollar-sign': {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M209.2 233.4c57.9 16.9 94 80.1 72.5 141.7-15.4 44.1-59.1 71.8-105.7 72.7v48.2c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48c-31.4-0.1-62-10.8-86.5-30-7.9-6.1-8.9-17.6-1.8-24.5l34.8-34c5.2-5.1 13.4-6.1 19.5-2 10 6.8 22 10.5 34.2 10.5h66.3c16.3 0 29.5-13.2 29.5-29.5 0-13-8.7-24.6-21.2-28.3l-102.5-30c-44.4-13-79.6-50.5-83.8-96.6-5.9-64.9 45.3-119.6 109-119.6h2.5v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c31.4 0.1 62 10.8 86.5 30 7.9 6.1 8.9 17.6 1.8 24.5l-34.8 34c-5.2 5.1-13.4 6.1-19.5 2-10-6.8-22-10.5-34.2-10.5h-66.3c-16.3 0-29.5 13.2-29.5 29.5 0 13 8.7 24.7 21.2 28.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dollar-sign.js
// module id = 1276
// module chunks = 0